import React from "react";
export function TrustListIcon(props) {
  return props.type === "globe" ? (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="27" fill="#E2BF78" />
      <path
        d="M41.6425 21.5484C40.0635 11.8262 36.3394 5 32.0054 5C27.6715 5 23.9474 11.8262 22.3684 21.5484H41.6425ZM21.5517 32C21.5517 34.4169 21.6824 36.7359 21.9111 38.9677H42.0889C42.3176 36.7359 42.4483 34.4169 42.4483 32C42.4483 29.5831 42.3176 27.2641 42.0889 25.0323H21.9111C21.6824 27.2641 21.5517 29.5831 21.5517 32ZM56.9093 21.5484C53.7949 14.156 47.49 8.44032 39.7042 6.13226C42.3612 9.8121 44.1906 15.3536 45.1488 21.5484H56.9093ZM24.2958 6.13226C16.5209 8.44032 10.2051 14.156 7.10163 21.5484H18.8621C19.8094 15.3536 21.6388 9.8121 24.2958 6.13226ZM58.0744 25.0323H45.5844C45.8131 27.3185 45.9437 29.6593 45.9437 32C45.9437 34.3407 45.8131 36.6815 45.5844 38.9677H58.0635C58.6624 36.7359 59 34.4169 59 32C59 29.5831 58.6624 27.2641 58.0744 25.0323ZM18.0672 32C18.0672 29.6593 18.1978 27.3185 18.4265 25.0323H5.93648C5.34846 27.2641 5 29.5831 5 32C5 34.4169 5.34846 36.7359 5.93648 38.9677H18.4156C18.1978 36.6815 18.0672 34.3407 18.0672 32ZM22.3684 42.4516C23.9474 52.1738 27.6715 59 32.0054 59C36.3394 59 40.0635 52.1738 41.6425 42.4516H22.3684ZM39.7151 57.8677C47.49 55.5597 53.8058 49.844 56.9201 42.4516H45.1597C44.2015 48.6464 42.3721 54.1879 39.7151 57.8677ZM7.10163 42.4516C10.216 49.844 16.5209 55.5597 24.3067 57.8677C21.6497 54.1879 19.8203 48.6464 18.8621 42.4516H7.10163Z"
        fill="#F7E7B9"
      />
    </svg>
  ) : props.type === "human" ? (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 18C27 20.3869 26.0518 22.6761 24.364 24.364C22.6761 26.0518 20.3869 27 18 27C15.6131 27 13.3239 26.0518 11.636 24.364C9.94821 22.6761 9 20.3869 9 18C9 15.6131 9.94821 13.3239 11.636 11.636C13.3239 9.94821 15.6131 9 18 9C20.3869 9 22.6761 9.94821 24.364 11.636C26.0518 13.3239 27 15.6131 27 18Z"
        fill="#EAD0B5"
      />
      <path
        d="M51 18C51 19.1819 50.7672 20.3522 50.3149 21.4442C49.8626 22.5361 49.1997 23.5282 48.364 24.364C47.5282 25.1997 46.5361 25.8626 45.4442 26.3149C44.3522 26.7672 43.1819 27 42 27C40.8181 27 39.6478 26.7672 38.5558 26.3149C37.4639 25.8626 36.4718 25.1997 35.636 24.364C34.8003 23.5282 34.1374 22.5361 33.6851 21.4442C33.2328 20.3522 33 19.1819 33 18C33 15.6131 33.9482 13.3239 35.636 11.636C37.3239 9.94821 39.6131 9 42 9C44.3869 9 46.6761 9.94821 48.364 11.636C50.0518 13.3239 51 15.6131 51 18Z"
        fill="#EAD0B5"
      />
      <path
        d="M38.79 50.9997C38.928 50.0187 39 49.0197 39 47.9997C39.0069 43.2863 37.4212 38.7087 34.5 35.0097C36.7803 33.6932 39.3669 33.0001 41.9999 33.0001C44.6329 33 47.2196 33.6931 49.4998 35.0096C51.7801 36.3261 53.6737 38.2196 54.9902 40.4998C56.3068 42.7801 56.9999 45.3667 57 47.9997V50.9997H38.79Z"
        fill="#EAD0B5"
      />
      <path
        d="M18 33C21.9782 33 25.7936 34.5804 28.6066 37.3934C31.4196 40.2064 33 44.0218 33 48V51H3V48C3 44.0218 4.58035 40.2064 7.3934 37.3934C10.2064 34.5804 14.0218 33 18 33Z"
        fill="#EAD0B5"
      />
    </svg>
  ) : props.type === "access" ? (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.5 27.5H12.5C9.73858 27.5 7.5 29.7386 7.5 32.5V50C7.5 52.7614 9.73858 55 12.5 55H47.5C50.2614 55 52.5 52.7614 52.5 50V32.5C52.5 29.7386 50.2614 27.5 47.5 27.5Z"
        fill="#948C77"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 29.3C10.7326 29.3 9.29995 30.7327 9.29995 32.5V50C9.29995 51.7673 10.7326 53.2 12.5 53.2H47.4999C49.2673 53.2 50.6999 51.7673 50.6999 50V32.5C50.6999 30.7327 49.2673 29.3 47.4999 29.3H12.5ZM5.69995 32.5C5.69995 28.7445 8.74441 25.7 12.5 25.7H47.4999C51.2555 25.7 54.2999 28.7445 54.2999 32.5V50C54.2999 53.7555 51.2555 56.8 47.4999 56.8H12.5C8.74441 56.8 5.69995 53.7555 5.69995 50V32.5Z"
        fill="#DFD9C5"
      />
      <path
        d="M17.5 25.6998V15.6998C17.5 12.3846 18.817 9.2052 21.1612 6.86099C23.5054 4.51679 26.6848 3.19983 30 3.19983C33.3152 3.19983 36.4946 4.51679 38.8388 6.86099C41.183 9.2052 42.5 12.3846 42.5 15.6998V25.6998"
        fill="#948C77"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 4.99978C27.1621 4.99978 24.4405 6.1271 22.4339 8.13374C20.4273 10.1404 19.3 12.862 19.3 15.6998V25.6998C19.3 26.6939 18.4941 27.4998 17.5 27.4998C16.5058 27.4998 15.7 26.6939 15.7 25.6998V15.6998C15.7 11.9072 17.2066 8.26992 19.8883 5.58815C22.5701 2.90638 26.2074 1.39978 30 1.39978C33.7925 1.39978 37.4298 2.90638 40.1116 5.58815C42.7934 8.26992 44.3 11.9072 44.3 15.6998V25.6998C44.3 26.6939 43.4941 27.4998 42.5 27.4998C41.5058 27.4998 40.7 26.6939 40.7 25.6998V15.6998C40.7 12.862 39.5726 10.1404 37.566 8.13374C35.5594 6.1271 32.8378 4.99978 30 4.99978Z"
        fill="#DFD9C5"
      />
    </svg>
  ) : props.type === "certificate" ? (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_310_6024)">
        <path
          d="M43.6448 100.928C41.2309 98.509 42.4893 99.1908 36.6671 97.6295C34.0255 96.9198 31.7033 95.556 29.6033 93.9223L17.0006 124.882C15.7812 127.88 18.0589 131.136 21.2867 131.013L35.9227 130.454L45.9892 141.108C48.2114 143.457 52.1114 142.725 53.3308 139.727L67.789 104.209C64.7779 105.89 61.4363 106.875 57.9808 106.875C52.5641 106.875 47.4753 104.763 43.6448 100.928ZM123 124.882L110.397 93.9223C108.297 95.5588 105.975 96.9198 103.333 97.6295C97.4804 99.1992 98.7637 98.5145 96.3554 100.928C92.5249 104.763 87.4332 106.875 82.0166 106.875C78.5611 106.875 75.2195 105.887 72.2084 104.209L86.6666 139.727C87.886 142.725 91.7887 143.457 94.0082 141.108L104.078 130.454L118.713 131.013C121.941 131.136 124.219 127.877 123 124.882ZM89.7221 94.6293C93.9665 90.3015 94.4526 90.6744 100.497 89.024C104.355 87.9692 107.372 84.8938 108.405 80.9584C110.483 73.0543 109.944 74.0089 115.614 68.2255C118.438 65.345 119.541 61.1452 118.508 57.2098C116.433 49.3113 116.43 50.4134 118.508 42.5065C119.541 38.5711 118.438 34.3713 115.614 31.4908C109.944 25.7074 110.483 26.6592 108.405 18.7579C107.372 14.8225 104.355 11.7471 100.497 10.6923C92.7526 8.57434 93.686 9.12818 88.011 3.34202C85.186 0.461463 81.0666 -0.665711 77.2083 0.389102C69.4668 2.50429 70.5473 2.50708 62.7918 0.389102C58.9335 -0.665711 54.8141 0.45868 51.9892 3.34202C46.3198 9.1254 47.2531 8.57434 39.506 10.6923C35.6477 11.7471 32.631 14.8225 31.5977 18.7579C29.5227 26.6592 30.0588 25.7074 24.3894 31.4908C21.5645 34.3713 20.4589 38.5711 21.495 42.5065C23.57 50.3995 23.5728 49.2973 21.495 57.2071C20.4617 61.1424 21.5645 65.3422 24.3894 68.2255C30.0588 74.0089 29.5199 73.0543 31.5977 80.9584C32.631 84.8938 35.6477 87.9692 39.506 89.024C45.7226 90.7217 46.1864 90.4545 50.2781 94.6293C53.953 98.3782 59.678 99.0489 64.0946 96.249C65.8607 95.1256 67.9095 94.5291 70.0015 94.5291C72.0935 94.5291 74.1422 95.1256 75.9084 96.249C80.3222 99.0489 86.0471 98.3782 89.7221 94.6293ZM43.7948 48.9745C43.7948 34.2155 55.528 22.2507 70.0001 22.2507C84.4722 22.2507 96.2054 34.2155 96.2054 48.9745C96.2054 63.7335 84.4722 75.6983 70.0001 75.6983C55.528 75.6983 43.7948 63.7335 43.7948 48.9745Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_310_6024">
          <rect width="140" height="140" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : props.type === "policy" ? (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64.1591 110.826C89.9324 110.826 110.826 89.9324 110.826 64.1591C110.826 38.3858 89.9324 17.4924 64.1591 17.4924C38.3858 17.4924 17.4924 38.3858 17.4924 64.1591C17.4924 89.9324 38.3858 110.826 64.1591 110.826Z"
        stroke="#2B2B2B"
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122.514 122.514L97.1387 97.1387"
        stroke="#2B2B2B"
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <></>
  );
}
export default TrustListIcon;
